export const useStorybookFigmaAddon = (link) => {
    if (!link)
        return;
    const url = link.startsWith('http')
        ? link
        : `https://www.figma.com/file/KLWxYdHAdFNvmt4WjEbCid/?node-id=${link}`;
    return {
        design: {
            type: 'figma',
            url,
        },
    };
};
//# sourceMappingURL=useStorybookFigmaAddon.js.map